import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';
export const getActualStockById = async ({ queryKey }) => {
	const [, id] = queryKey;
	const url = `estoque/estoqueById?id=${id}`;
	const response = await api.get(url);
	return response.data;
};

export const useGetActualStockWithId = (id: Number) => {
	return useQuery(['actualStockWithId', id], getActualStockById, {
		onError: error => {
			console.log(error);
		},
		refetchOnWindowFocus: false,
	});
};
